import React from 'react';
import css from './UnclaimedBanner.module.css';

/**
 * Subtle banner shown on listing detail pages when the underlying listing
 * was created from public data and not yet claimed by the business owner.
 * Per the vendor-claim spec §1.3.
 *
 * Renders nothing if the listing is already claimed or the publicData flag
 * is missing.
 */
const UnclaimedBanner = ({ publicData }) => {
  if (!publicData || publicData.claimed === true || publicData.claimed === undefined) {
    return null;
  }
  return (
    <div className={css.banner}>
      <div className={css.icon} aria-hidden="true">ℹ️</div>
      <div className={css.body}>
        <div className={css.title}>This profile was created from public information</div>
        <div className={css.text}>
          Are you the owner? Email <a href="mailto:hello@cafiredefense.com" className={css.link}>hello@cafiredefense.com</a> to claim it (we'll send you a secure link).
        </div>
      </div>
    </div>
  );
};

export default UnclaimedBanner;
